var window=global;var $CLJS=require("./cljs_env.js");
'use strict';var kga=require("moment-timezone");module.exports=kga;